<template>
  <!-- 系统配置页 -->
  <div class="index">
    <!-- 顶部 demo 预览 保存 -->
    <div class="header">
      <index-header :project_name="ProjectInfo.Name"></index-header>
    </div>
    <div class="body" :style="getBodySizeStyle()">
      <!-- 左侧 背景 - 风格 - 图表 管理 -->
      <div class="left-menu" :style="IndexInfo.isOpenLeftMenu ? {} : { width: '40px' }">
        <div class="toggle-btn-left" @click="handleToggleBtn('left')">
          <i class="arrow el-icon-back" :class="{ closed: !IndexInfo.isOpenLeftMenu }"></i>
        </div>
        <index-left-menu></index-left-menu>
      </div>
      <!-- 中间主内容 -->
      <div class="work-bench-wrapper" id="work-bench-wrapper">
        <index-workbench
          :asyncProjectInfo="ProjectInfo"
          :is_open_right_menu="IndexInfo.isOpenRightMenu"
          :is_open_left_menu="IndexInfo.isOpenLeftMenu"
        ></index-workbench>
      </div>
      <div class="right-menu" :style="IndexInfo.isOpenRightMenu ? {} : { width: '0px' }">
        <div class="toggle-btn-right" @click="handleToggleBtn('right')">
          <i class="arrow el-icon-right" :class="{ closed: !IndexInfo.isOpenRightMenu }"> </i>
        </div>

        <div class="thumb-nail-wrraper">
          <index-thumb-nail></index-thumb-nail>
        </div>
        <!-- 右侧 数据调整 管理 -->
        <index-right-menu :CurrentConfigration="$store.state.CurrentConfigration"></index-right-menu>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapMutations } from 'vuex';

import IndexHeader from '@/views/indexviews/IndexHeader.vue';
import IndexWorkbench from '@/views/indexviews/IndexWorkbench.vue';
import IndexLeftMenu from '@/views/indexviews/IndexLeftMenu.vue';
import IndexRightMenu from '@/views/indexviews/IndexRightMenu.vue';
import IndexThumbNail from '@/views/indexviews/IndexThumbNail.vue';

export default {
  name: 'Index',
  components: {
    IndexHeader,
    IndexWorkbench,
    IndexLeftMenu,
    IndexRightMenu,
    IndexThumbNail,
  },
  data() {
    return {
      TimerId: null,
      loadingInstance: null,

      robotShow: false,
      digitalhumanSrc: '',
    };
  },
  created() {
    this.checkLoginStatus();
    this.$store.commit('setLoading', true);
    this.$store.dispatch('getProject');
    this.$store.commit('set_editMode', true);
  },
  beforeMount() {},
  watch: {
    robotShow(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.digitalhumanRef.left = this.initialX;
          this.$refs.digitalhumanRef.top = this.initialY;
        }, 600);
      }
    },
  },
  mounted() {
    this.hideLoading();
  },
  beforeUnmount() {
    this.$store.commit('set_editMode', false);
  },
  beforeDestroy() {
    // 移除事件总线相关代码
  },
  methods: {
    ...mapMutations(['set_IndexInfo']),

    checkLoginStatus() {
      // 获取本地的用户信息
      let origin_userInfo = window.localStorage.getItem('origin_userInfo');
      let project_row_id = window.localStorage.getItem('project_row_id');
      // 检查本地登录原始用户信息是否存在

      // 如果其中一个不存在就退出
      if (!origin_userInfo || !project_row_id) {
        window.localStorage.removeItem('origin_userInfo');
        window.localStorage.removeItem('project_row_id');
        window.localStorage.setItem('logOut', 'yes');
        this.$router.push({ name: 'Manager' });
      }
    },
    hideLoading() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$store.commit('setLoading', false);
        }, 500);
      });
    },
    getBodySizeStyle() {
      return {
        width: '100%',
        height: this.ClientViewSize.height - 40 + 'px',
      };
    },
    handleToggleBtn(key) {
      if (key === 'right') {
        this.set_IndexInfo({
          isOpenRightMenu: !this.IndexInfo.isOpenRightMenu,
        });
        console.log(this.IndexInfo);
      } else if (key === 'left') {
        this.set_IndexInfo({
          isOpenLeftMenu: !this.IndexInfo.isOpenLeftMenu,
        });
        console.log(this.IndexInfo);
      }
    },
  },
  computed: {
    ...mapState({
      ClientViewSize: state => state.ClientViewSize,
      IndexInfo: state => state.IndexInfo,
      ProjectInfo: state => state.ProjectInfo,
    }),
  },
};
</script>

<style lang="scss" scoped>
.index {
  width: 100%;
  height: 100%;
  color: $font-color-base;
  position: relative;
  .loading-mask {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: $loading-mask-color;
    z-index: 9999;
  }
  .header {
    width: 100%;
    height: 40px;
    background-color: $background-color-medium;
  }
  .body {
    width: 100%;
    background-color: $background-color-heavy;
    display: flex;
    // overflow: hidden;
  }
  .left-menu {
    position: relative;
    height: 100%;
    width: 280px;
    flex-shrink: 0;
    background-color: $background-color-light;
    transition: all 0.3s ease-out;

    .toggle-btn-left {
      position: absolute;
      top: 5px;
      right: -34px;
      height: 30px;
      width: 30px;
      border-radius: 0px 3px 3px 0px;
      background: #383a4c;

      transition: all 0.3s ease-out;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 99;
      color: #ffffff;
      .arrow {
        transition: all 0.5s 0.3s;
      }
      &:hover {
        background: linear-gradient(143deg, #335ae9, #6f6ff5);
        color: #fff;
      }
      .closed {
        transform: rotate(-180deg);
      }
    }
  }
  .right-menu {
    position: relative;
    height: 100%;
    width: 280px;
    flex-shrink: 0;
    background-color: $background-color-light;
    transition: all 0.3s ease-out;

    .toggle-btn-right {
      position: absolute;
      top: 5px;
      left: -34px;
      height: 30px;
      width: 30px;
      border-radius: 3px 0px 0px 3px;
      background: #383a4c;

      transition: all 0.3s ease-out;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 99;
      color: #ffffff;
      .arrow {
        transition: all 0.5s 0.3s;
      }
      &:hover {
        background: linear-gradient(143deg, #335ae9, #6f6ff5);
        color: #fff;
      }
      .closed {
        transform: rotate(-180deg);
      }
    }
    .thumb-nail-wrraper {
      z-index: 9999999 !important;
      width: 190px;
      height: 110px;
      background-color: $background-color-heavy;

      overflow: hidden;
      position: absolute;
      left: -200px;
      bottom: 10px;
      @media (max-width: 768px) {
        left: 10px;
        bottom: 10px;
      }
    }
  }
  .work-bench-wrapper {
    height: 100%;
    width: 100%;
    overflow: hidden;
  }
}
</style>
